export default __webpack_public_path__ + "static/media/face_1_50.086cefc9.png";